import type { NoContext } from '~/services/api/contracts/NoContext'
import { LogoutOtherSessionsRequestSchema } from '~/services/api/generated'
import { strictify } from '~/utils/strictify'

export const UserAccessLogoutOtherSessions = (_context: NoContext = {}) =>
  strictify(LogoutOtherSessionsRequestSchema)
